const master = () => import(/* webpackChunkName: "master" */ '@/views/page/master/index.vue');
const search = () => import(/* webpackChunkName: "master" */ '@/views/page/master/search.vue');
const release = () => import(/* webpackChunkName: "master" */ '@/views/page/master/release.vue');
const masterDetails = () => import(/* webpackChunkName: "master" */ '@/views/page/master/details.vue');
const liuhe = () => import(/* webpackChunkName: "master" */ '@/views/page/master/liuhe.vue');

const masterRoute = [
    {
        path: '/master',
        name: 'master',
        component: master,
        meta: {
            keepAlive: true,
          },
    },
    {
        path: '/master/search',
        name: 'masterSearch',
        component: search,
       
    },
    {
        path: '/master/release',
        name: 'masterRelease',
        component: release,
        meta:{
            needLogin: true,
        }
   
    },
    {
        path: '/master/details',
        name: 'masterDetails',
        component: masterDetails,
  
    },
    {
        path: '/master/liuhe',
        name: 'liuhe',
        component: liuhe,
  
    },

    
]

export default masterRoute
